import { type InputProps as Props, Translation } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';
import { useField } from 'react-final-form';

import InputSection from '../InputSection/InputSection';

import { TXTCLI_Please_enter_a_valid_SSN } from './SSNTextInput.messages.json';
import styles from './SSNTextInput.scss';

interface InputProps extends Props {
  checkDisabled?: boolean;
}

const SSN_FIELDS = [
  { id: 'ssn1', length: 3, placeholder: '000', maxLength: 3 },
  { id: 'ssn2', length: 2, placeholder: '00', maxLength: 2 },
  { id: 'ssn3', length: 4, placeholder: '0000', maxLength: 4 }
] as const;

const SSNTextInput: React.FC<InputProps> = ({ ...props }) => {
  const fields = SSN_FIELDS.map(({ id }) => {
    const {
      meta: { touched, error }
    } = useField(id);
    return { id, touched, error };
  });

  const hasValidationErrors = fields.some(({ touched, error }) => touched && error);

  return (
    <>
      <div className={classNames(styles.ssnGroup)}>
        {SSN_FIELDS.map((field, index) => (
          <React.Fragment key={field.id}>
            <InputSection
              {...props}
              id={field.id}
              length={field.length}
              placeholder={field.placeholder}
              maxLength={field.maxLength}
              pattern="numericKeyboard"
            />
            {index < SSN_FIELDS.length - 1 && <div className={classNames(styles.ssnDash)}> - </div>}
          </React.Fragment>
        ))}
      </div>
      {hasValidationErrors && (
        <p className={styles.validationWarning}>
          <Translation {...TXTCLI_Please_enter_a_valid_SSN} />
        </p>
      )}
    </>
  );
};

export default SSNTextInput;
